import CustomerLoader from "../../../../../components/CustomLoader";
import {
  doTransformData,
  fallIncidentPlaceCols,
  handlePointClicked,
  transformDataForBarChart,
} from "../formUtils";
import { LayerContent } from "../style";
import { useAnalyticsWrapper } from "../../../../../store/store";
import useAnalytics from "../../../../../hooks/useAnalytics";
import moment from "moment";
import { Fragment, useEffect, useState } from "react";
import SectionModal, { DefaultContainer } from "./SectionModal";
import {
  handleCSVDownload,
  handlePDFDownload,
} from "../../../../../utils/helpers/pdfCsvUtils";
import { incidentLists } from "../../dummyData/colums";
import { Grid, GridColumn, GridColumnProps } from "@progress/kendo-react-grid";
import {
  CenteredWholeNumCell,
  HeaderCenteredCell,
} from "../../../../../components/DynamicGrid/customCells";
import { TotalRow } from "../../../../../components/DynamicGrid/customRows";

const ActivityPriorIncident = ({
  setClickedIncident,
  isFetchingSelectedIncident,
  shareTableData,
}: any) => {
  const [tableData, setTableData] = useState<any>([]);
  const [grid, setGrid] = useState<any>([]);
  const [barData, setBarData] = useState<any>([]);
  const [residentAction, setResidentAction] = useState("");
  const [showActivityModal, setShowActivityModal] = useState(false);
  const [activityPriorDetails, setActivityPriorDetails] = useState<any>([]);

  const { startDate, endDate, fallFacility } = useAnalyticsWrapper((state) => ({
    startDate: state.startDate,
    endDate: state.endDate,
    fallFacility: state.fallFacility,
  }));

  const { getActivityPriorIncient, getActivityPriorDetails } = useAnalytics({
    facility: fallFacility?.value || "",
    startDate: moment(startDate).format("yyyy-MM-DD"),
    endDate: moment(endDate).format("yyyy-MM-DD"),
    residentAction: residentAction,
  });

  const {
    data: activityPriorIncidentData,
    isFetching: isFetchingActivityPriorIncident,
  } = getActivityPriorIncient;

  const { data: activityPriorDetailsData, isFetching: isLoadingDetails } =
    getActivityPriorDetails;

  useEffect(() => {
    if (activityPriorIncidentData) {
      const tempData = activityPriorIncidentData?.data.data;
      const transformedTableData = doTransformData(
        tempData,
        "residentActionBeforeIncident",
        "place",
        "Total"
      );
      const transformedBarData = transformDataForBarChart(
        transformedTableData,
        "Overview Count"
      );
      setTableData(transformedTableData);
      shareTableData(transformedTableData);
      setBarData(transformedBarData);
    }
  }, [activityPriorIncidentData]);

  useEffect(() => {
    if (activityPriorDetailsData) {
      const tempDetails = activityPriorDetailsData.data.data.map((item: any) => ({
        ...item
      }));
      setActivityPriorDetails(tempDetails);
    }
  }, [activityPriorDetailsData]);

  const title = "Activity Prior to Incident";

  const handleBarClicked = (chart: any) => {
    if (!chart.length) return;
    const label = handlePointClicked(chart, barData?.labels);
    setShowActivityModal(true);
    setResidentAction(label);
  };

  useEffect(() => {
    let cellCountProps = {
      cells: { data: CenteredWholeNumCell, headerCell: HeaderCenteredCell },
    };
    let cellPercentageProps = {
      cells: {
        data: CenteredWholeNumCell,
        append: "%",
        headerCell: HeaderCenteredCell,
      },
    };
    const grid = (
      <Fragment>
        <Grid
          data={tableData || []}
          scrollable="none"
          rows={{ data: TotalRow }}
        >
          <GridColumn field="place" title="Place" />
          <GridColumn
            field="count"
            title="Number"
            {...(cellCountProps as GridColumnProps)}
          />
          <GridColumn
            field="percentage"
            title="%"
            {...(cellPercentageProps as GridColumnProps)}
          />
        </Grid>
      </Fragment>
    );
    setGrid(grid);
  }, [tableData]);

  return (
    <LayerContent>
      {isFetchingActivityPriorIncident ? (
        <CustomerLoader />
      ) : (
        <DefaultContainer
          title={title}
          grid={grid}
          handleBarClicked={(chart: any) => handleBarClicked(chart)}
          barData={barData}
          barType="vertical"
        />
      )}
      {showActivityModal ? (
        <SectionModal
          open={showActivityModal}
          facilityName={fallFacility?.label}
          startDate={startDate}
          endDate={endDate}
          closeFn={() => setShowActivityModal(false)}
          resetFn={() => {
            setResidentAction("");
            setActivityPriorDetails(undefined);
          }}
          isLoading={isLoadingDetails || isFetchingSelectedIncident}
          tableData={activityPriorDetails}
          title={`${title} - ${residentAction}`}
          getUserCallback={(item: any) => setClickedIncident(item)}
          handlePdfExport={() =>
            handlePDFDownload({
              data: activityPriorDetails,
              columnData: incidentLists(),
              fileName: fallFacility?.label,
              startDate,
              endDate,
              subTitle: `${title} - ${residentAction}`,
            })
          }
          handleCsvExport={() =>
            handleCSVDownload(
              activityPriorDetails,
              incidentLists(),
              `${fallFacility?.label} - ${title} - ${residentAction}`
            )
          }
        />
      ) : null}
    </LayerContent>
  );
};

export default ActivityPriorIncident;
